import Vue from "vue";

import ChangePassword from "./ChangePassword.vue";

export function load() {
    const selector = "change-password";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(ChangePassword, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
